// extracted by mini-css-extract-plugin
export default {"fullWidth":"Vn-z","image":"Wn-z","lazyLoadPicture":"Xn-z","lazyLoadSpinner":"Yn-z","lazyLoadSpin":"Zn-z","lazyLoadImage":"_n-z","hasStyledAspectRatio":"ao-z"};